import { Modal, Table, TableBody, TableContainer, ThemeProvider, createTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { extractDetailModalOpenState, extractDetailDataState } from "../../../atoms/myWallet";
import { useCallback } from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import MyWalletExtractDetailTableHead from "./MyWalletExtractDetailTableHead";
import MyWalletExtractDetailTableBody from "./MyWalletExtractDetailTableBody";

const theme = createTheme({
  components: {
    MuiModal: {
      styleOverrides: {
        root: {
          margin: "20px",
          overflow: "auto",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          display: "flex",
          alignItems: "center",
          gap: "10px",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "14px",
          opacity: 0.8,
        },
      },
    },
  },
});

const MyWalletExtractDetailModal = () => {
  const [extractDetailModalOpen, setExtractDetailModalOpen] = useRecoilState(
    extractDetailModalOpenState
  );
  const [extractDetailData, setExtractDetailData] = useRecoilState(extractDetailDataState);

  const handleClose = useCallback(() => {
    setExtractDetailModalOpen(false);
    setExtractDetailData([]);
  }, [setExtractDetailModalOpen, setExtractDetailData]);

  return (
    <ThemeProvider theme={theme}>
      <Modal open={extractDetailModalOpen} onClose={handleClose}>
        <TableContainer
          sx={{
            backgroundColor: "var(--lighterBg)",
            borderRadius: "var(--inputBorderRadius)",
            padding: "20px",
            outline: 0,
            display: "grid",
            gap: "var(--gap)",
            width: "100%",
            maxWidth: "1400px",
            margin: "auto",
            position: "relative",
          }}
          style={{
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <CancelOutlinedIcon
            sx={{
              position: "absolute",
              right: 1,
              top: 1,
              cursor: "pointer",
              color: "var(--priceText)",
              transition: "all 80ms linear",
              ":hover": {
                color: "var(--notRed)",
                transition: "all 80ms linear",
              },
            }}
            onClick={handleClose}
          />
          <Table>
            <MyWalletExtractDetailTableHead />
            <TableBody>
              {extractDetailData?.map((row, key) => (
                <MyWalletExtractDetailTableBody row={row} key={key} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Modal>
    </ThemeProvider>
  );
};

export default MyWalletExtractDetailModal;
